module.exports = __webpack_public_path__ + "static/media/SupportaTroop_Logo_BlackTxt.4ec8ff0d.png";